import { TagCombinedProps } from './types';

const usePresenter = (props: TagCombinedProps): TagCombinedProps => {
  return props;
};

export default usePresenter;
